var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4569_10121)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5002 6.25C22.9145 6.25 23.2502 6.58579 23.2502 7V8.25H25.0002C25.4145 8.25 25.7502 8.58579 25.7502 9C25.7502 9.41421 25.4145 9.75 25.0002 9.75H23.2502V12.3413C24.1958 12.5765 24.8895 13.2235 25.3359 13.7815C25.6224 14.1396 25.8343 14.4936 25.9745 14.7564C26.0451 14.8887 26.0987 15.0003 26.1355 15.0808C26.1539 15.1211 26.1682 15.1538 26.1784 15.1776L26.1833 15.1893C26.5898 16.021 26.6196 17.038 26.4831 18.0419C27.504 17.3504 28.6088 16.8372 29.7392 16.5269C33.195 15.5783 36.937 16.5288 39.139 20.1071C39.1505 20.1258 39.1612 20.1451 39.171 20.1647C40.8938 23.6103 39.1036 26.5824 37.1556 28.5305C36.1685 29.5175 35.091 30.2998 34.267 30.833C33.8547 31.0998 33.5019 31.3067 33.2502 31.4479V38.0002C33.2502 38.2566 33.1192 38.4952 32.9029 38.6329C30.006 40.4763 26.2328 41.3752 22.5002 41.3752C18.7676 41.3752 14.9944 40.4763 12.0976 38.6329C11.8812 38.4952 11.7502 38.2566 11.7502 38.0002V31.4479C11.4985 31.3067 11.1458 31.0998 10.7334 30.833C9.90947 30.2998 8.83193 29.5175 7.84489 28.5305C5.89686 26.5824 4.1066 23.6103 5.8294 20.1647C5.83924 20.1451 5.84995 20.1258 5.86148 20.1071C8.06348 16.5288 11.8055 15.5783 15.2613 16.5269C16.3917 16.8372 17.4965 17.3504 18.5174 18.0419C18.3809 17.038 18.4107 16.021 18.8172 15.1893L18.8221 15.1776C18.8323 15.1538 18.8466 15.1211 18.865 15.0808C18.9018 15.0003 18.9554 14.8887 19.026 14.7564C19.1661 14.4936 19.3781 14.1396 19.6646 13.7815C20.1109 13.2235 20.8047 12.5765 21.7502 12.3413V9.75H20.0002C19.586 9.75 19.2502 9.41421 19.2502 9C19.2502 8.58579 19.586 8.25 20.0002 8.25H21.7502V7C21.7502 6.58579 22.086 6.25 22.5002 6.25Z",
    fill: "#2F3233"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.63V6",
    stroke: "#1A1818",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 25C22.5 25 27 17.5 25.5 14.5C25.5 14.5 24.5 12 22.5 12C20.5 12 19.5 14.5 19.5 14.5C18 17.5 22.5 25 22.5 25Z",
    stroke: "#1A1818",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 37.0001C17.9999 40.5001 26.9999 40.5001 32.4999 37.0001V30.0001C32.4999 30.0001 41.4999 25.5001 38.4999 19.5001C34.4999 13.0001 24.9999 16.0001 22.4999 23.5001C19.9999 16.0001 10.4999 13.0001 6.49994 19.5001C3.49994 25.5001 12.4999 30.0001 12.4999 30.0001V37.0001Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 23.5001C24.9999 16.0001 34.4999 13.0001 38.4999 19.5001C41.4999 25.5001 32.4999 30.0001 32.4999 30.0001V37.0001C26.9999 40.5001 17.9999 40.5001 12.4999 37.0001V30.0001C12.4999 30.0001 3.49994 25.5001 6.49994 19.5001C10.4999 13.0001 19.9999 16.0001 22.4999 23.5001ZM22.4999 23.5001V27.0001",
    stroke: "#1A1818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H25",
    stroke: "#1A1818",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 29.4999C31.9997 29.4999 40.4997 25.4999 38.0297 19.8499C34.1497 13.9999 24.9997 17.9999 22.4997 24.4999M22.4997 24.4999V26.5999M22.4997 24.4999C19.9997 17.9999 10.8497 13.9999 6.96968 19.8499C4.49968 25.4999 12.9997 29.4999 12.9997 29.4999",
    stroke: "#E9E9E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30.1892C18.225 27.2703 26.775 27.2703 32 30.1892M13 33.5946C18.225 30.6757 26.775 30.6757 32 33.5946M13 37C18.225 34.0811 26.775 34.0811 32 37",
    stroke: "#E9E9E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4569_10121",
    x: 4.13477,
    y: 6.25,
    width: 36.731,
    height: 37.1252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_10121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_10121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBk);
export default __webpack_public_path__ + "static/media/bk.fd024825b422579739c2b3c4b724abfd.svg";
export { ForwardRef as ReactComponent };